import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PLACE_BY_ID } from '../../operations/queries/get-place-by-id.js';
import fromPlaceByIdQueryToPlaceById from './adapters/fromPlaceByIdQueryToPlaceById.js';

const usePlaceById = (variables)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_BY_ID, {
        variables,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getPlaceById.error');
            console.error('Failed to fetch place by id: ', error);
        }
    });
    return React__default.useMemo(()=>{
        var ref;
        return [
            query,
            swcHelpers.objectSpread({}, queryState, {
                data: fromPlaceByIdQueryToPlaceById((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placeById)
            }), 
        ];
    }, [
        query,
        queryState
    ]);
};
var usePlaceById$1 = usePlaceById;

export { usePlaceById$1 as default };
//# sourceMappingURL=use-place-by-id.js.map
